import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import { useTranslation } from 'react-i18next'
import { supportedLanguages, languageConfig, type SupportedLanguage } from '@/i18n'
import { useState, useEffect } from 'react'
import Ripple from '@/components/Ripple'

export default function SetLang() {
    const { t, i18n } = useTranslation()
    const [isFollowingSystem, setIsFollowingSystem] = useState(false)

    // 检查是否正在跟随系统语言
    useEffect(() => {
        const followSystem = localStorage.getItem('followSystemLanguage') === 'true'
        setIsFollowingSystem(followSystem)
    }, [])

    // 获取系统语言
    const getSystemLanguage = (): SupportedLanguage => {
        const systemLang = navigator.language || navigator.languages[0]
        console.log('系统语言:', systemLang)
        // 匹配系统语言到支持的语言
        if (systemLang.startsWith('zh-CN') || systemLang.startsWith('zh')) {
            return 'zh-CN'
        } else if (systemLang.startsWith('zh-TW') || systemLang.startsWith('zh-HK')) {
            return 'zh-TW'
        } else if (systemLang.startsWith('ja')) {
            return 'ja'
        } else if (systemLang.startsWith('ko')) {
            return 'ko'
        } else if (systemLang.startsWith('fr')) {
            return 'fr'
        } else {
            return 'en' // 默认英文
        }
    }

    // 处理跟随系统语言
    const handleFollowSystem = () => {
        const systemLang = getSystemLanguage()
        localStorage.setItem('followSystemLanguage', 'true')
        localStorage.setItem('i18nextLng', systemLang)
        i18n.changeLanguage(systemLang)
        setIsFollowingSystem(true)
    }

    // 处理手动选择语言
    const handleLanguageChange = (language: SupportedLanguage) => {
        localStorage.setItem('followSystemLanguage', 'false')
        localStorage.setItem('i18nextLng', language)
        i18n.changeLanguage(language)
        setIsFollowingSystem(false)
    }

    return (
        <PageLayout>
            <Header
                leftChildren={<Back />}
                centerChildren={<span className="text-3.75 font-medium text-black">{t('语言设置')}</span>}
            />
            <div className='px-6 pb-6 bg-white'>
                {/* 跟随系统语言选项 */}
                <Ripple className='rounded-2 mt-4 w-full'>
                    <div
                        className='flex justify-between items-center py-4 border-[0.5px] cursor-pointer'
                        onClick={handleFollowSystem}
                    >
                        <div className='text-[#1A1A1A] text-base font-medium'>
                            {t('跟随系统语言')}
                        </div>
                        <div className='flex items-center'>
                            {isFollowingSystem && (
                                <div className='w-4 h-4 bg-[var(--primary-color)] rounded-full'></div>
                            )}
                        </div>
                    </div>
                </Ripple>
                {/* 手动语言选择 */}
                {supportedLanguages.map((lang) => (
                    <Ripple key={lang} className='rounded-2 w-full'>
                        <div key={lang}
                            className='flex rounded-2 justify-between items-center py-3 border-[0.5px] border-b-solid border-[#E5E5E5] cursor-pointer'
                            onClick={() => handleLanguageChange(lang)}>
                            <div className='text-[#1A1A1A] text-base font-medium'>
                                {languageConfig[lang].nativeName}
                            </div>
                            <div className='flex items-center'>
                                {!isFollowingSystem && i18n.language === lang && (
                                    <div className='w-4 h-4 bg-[var(--primary-color)] rounded-full'></div>
                                )}
                            </div>
                        </div>
                    </Ripple>
                ))}
            </div>
        </PageLayout>
    )
}
